export const IS_DEV = process.env.REACT_APP_REACT_ENV === 'DEVELOPMENT';
export const IS_PRE = process.env.REACT_APP_REACT_ENV === 'PREPRODUCTION';
export const IS_PROD = process.env.REACT_APP_REACT_ENV === 'PRODUCTION';
export const IS_NON_PROD = !IS_PROD;
